import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames/bind';

import Type from '../Typography';

import styles from './DotMask.less';

const cxb = cx.bind(styles);

DotMask.propTypes = {
  inModal: PropTypes.bool,
  children: PropTypes.node,
};

/**
 * **Access:**
 * ```js
 * import { DotMask } from '@iss/client-react-components'
 * ```
 *
 * Puts up a mask with a short message and three animated dots. This component is
 * positioned absolutely and depends on the offsetParent to define height/width.
 */
export default function DotMask({ children, className, inModal, ...props }) {
  return (
    <div className={cxb('root', { inModal })} {...props}>
      <Type.Heading1 className={cxb('label')}>{children}</Type.Heading1>
      <div className={cxb('indicator')}>
        <Dot />
        <Dot />
        <Dot />
      </div>
    </div>
  );
}

function Dot() {
  return (
    <svg viewBox="0 0 23 23" xmlns="http://www.w3.org/2000/svg" width="23" height="23">
      <circle cx="50%" cy="50%" r="11.5" />
    </svg>
  );
}
